import { DOMNode } from 'html-react-parser';
import React, { ReactNode, createContext, useMemo } from 'react';

type NotesContextType = {
  notes: string[];
  replace?: (domNode: DOMNode) => DOMNode | React.JSX.Element;
};

type NotesContextProviderProps = {
  notes: string[];
  replace: (domNode: DOMNode) => DOMNode | React.JSX.Element;
  children: ReactNode;
};

export const NotesContext = createContext<NotesContextType>({
  notes: [],
});

export function NotesContextProvider({ notes, replace, children }: NotesContextProviderProps) {
  const value = useMemo(() => ({ notes, replace }), [notes, replace]);

  return (
    <NotesContext.Provider value={value}>
      {children}
    </NotesContext.Provider>
  );
}
